import { render, staticRenderFns } from "./adriftList.vue?vue&type=template&id=1af99852&scoped=true&"
import script from "./adriftList.vue?vue&type=script&lang=js&"
export * from "./adriftList.vue?vue&type=script&lang=js&"
import style0 from "./adriftList.vue?vue&type=style&index=0&id=1af99852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af99852",
  null
  
)

export default component.exports